import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import LegalTextModal from "./components/LegalTextModal";
import ModalContextProvider from "./contexts/ModalContext";
import Stage from "./sections/Stage";
import Intro from "./sections/Intro";
import TariffTiles from "./sections/TariffTiles";

ReactDOM.render(
  <React.StrictMode>
    <ModalContextProvider>
      <Stage />
      <LegalTextModal />
    </ModalContextProvider>
  </React.StrictMode>,
  document.getElementById("churn-lp-dp-stage")
);

ReactDOM.render(
  <React.StrictMode>
    <ModalContextProvider>
      <Intro />
      <LegalTextModal />
    </ModalContextProvider>
  </React.StrictMode>,
  document.getElementById("churn-lp-dp-intro")
);

ReactDOM.render(
  <React.StrictMode>
    <ModalContextProvider>
      <TariffTiles />
      <LegalTextModal />
    </ModalContextProvider>
  </React.StrictMode>,
  document.getElementById("churn-lp-dp-tariff-tiles")
);
